module.exports = __webpack_public_path__ + "img/vpss.6c84c6a.png";